import { FleekError } from './FleekError';

type FleekFunctionNameNotValidErrorOptions = {
  name: string;
};

export class FleekFunctionNameNotValidError extends FleekError<FleekFunctionNameNotValidErrorOptions> {
  public name = 'FleekFunctionNameNotValidError';

  toString = () => {
    return `The name, ${this.data.name}, is invalid`;
  };
}
